import { render, staticRenderFns } from "./PackageProcedure.vue?vue&type=template&id=17abc724&scoped=true"
import script from "./PackageProcedure.vue?vue&type=script&lang=js"
export * from "./PackageProcedure.vue?vue&type=script&lang=js"
import style0 from "./PackageProcedure.vue?vue&type=style&index=0&id=17abc724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17abc724",
  null
  
)

export default component.exports